import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivityRegistryDto } from './activity-registry-dto';
import { OeAppService } from '../../shared/oe-app.service';

@Injectable()
export class ActivityRegistryService {
  constructor(private http: HttpClient,
      private oeAppService: OeAppService) {}

  getActivityRegistryData(personId: number): Observable<ActivityRegistryDto> {
    const url = `${this.oeAppService.oeProgressServiceHost}/v1/activities?personId=${personId}`;
    return this.http.get<ActivityRegistryDto>(url);
  }
}



// WEBPACK FOOTER //
// ./ts/app/activity-registry/activity-registry-service/activity-registry.service.ts